(() => {
  const init = () => {
    document.querySelectorAll('[data-sh-sticky-atc]').forEach((bar) => {
      const sectionId = bar.dataset.section;
      const submit = document.getElementById(`ProductSubmitButton-${sectionId}`);
      const button = bar.querySelector('[data-sh-sticky-submit]');
      const priceEl = bar.querySelector('[data-sh-sticky-price]');
      if (!submit || !button) return;

      const sync = () => {
        const disabled = submit.hasAttribute('disabled') || submit.getAttribute('aria-disabled') === 'true';
        button.disabled = disabled;
        const label = submit.querySelector('span')?.textContent.trim();
        if (label) button.textContent = label;
        const price = document.getElementById(`price-${sectionId}`);
        if (price && priceEl) {
          const onSale = price.querySelector('.price--on-sale');
          const el = onSale
            ? price.querySelector('.price__sale .price-item--sale')
            : price.querySelector('.price__regular .price-item--regular');
          if (el) priceEl.textContent = el.textContent.trim();
        }
      };

      new MutationObserver(sync).observe(submit, { attributes: true, childList: true, subtree: true, characterData: true });
      sync();
      button.addEventListener('click', () => submit.click());

      let revealed = false;
      // Root extended far below the viewport: "not intersecting" then means the button is entirely
      // above the top edge, so even a scroll jump that skips the button flips the state.
      const observer = new IntersectionObserver(
        ([entry]) => {
          const scrolledPast = !entry.isIntersecting && entry.boundingClientRect.top < 0;
          if (scrolledPast && !revealed) {
            revealed = true;
            bar.hidden = false;
          }
          if (!revealed) return;
          bar.classList.toggle('sh-sticky-atc--visible', scrolledPast);
          bar.setAttribute('aria-hidden', String(!scrolledPast));
          button.tabIndex = scrolledPast ? 0 : -1;
          document.documentElement.classList.toggle('sh-sticky-atc-active', scrolledPast);
        },
        { threshold: 0, rootMargin: '0px 0px 100000px 0px' }
      );
      observer.observe(submit);
    });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
